<template>
  <div id="app">
    <div
      v-if="user"
      class="wrapper"
    >
      <Header />
      <Sidebar />
      <router-view />
    </div>
    <div
      v-if="!user"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/OrHeader'
import Sidebar from '@/components/organisms/OrSidebar'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar
  },
  data () {
    return {
      user_token: localStorage.getItem('token')
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user || this.user_token) return true
      return false
      /* if (localStorage.getItem('token') === '1') {
        return true
      }
      if (this.$store.state.Auth.user) {
        return true
      }
      return false */
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'Top' && from.path === '/' && window.location.href.indexOf('M0002SNSLink')) {
        // window.location.replace('http://localhost:8080/#/M0002SNSLink/' + location.search.substr(1, location.search.length))
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('Auth/initUser')
      .then(user => {
        this.user_token = localStorage.getItem('token')
        if (!user) {
          localStorage.removeItem('token')
          if (this.$route.name !== 'Login' && this.$route.name !== 'M0001UserEditForm') this.$router.push('/Login')
        } else {
          if (this.$route.name === 'Login') {
            this.$router.push({name: 'Top'})
          }
        }
      })
  }
}
</script>

<style>
.fa-facebook{
  color:mediumblue
}
.fa-pinterest{
  color:red
}
.fa-twitter{
  color:skyblue
}
.fa-youtube{
  color:red
}
.fa-instagram{
  color: transparent;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
  background: -webkit-radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
  background-clip: text;
  -webkit-background-clip: text;
}
.fa-linkedin{
  color:royalblue
}
.fa-weixin{
  color:yellowgreen
}
.fa-weibo{
  color: transparent;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%);
  background: -webkit-radial-gradient(circle at 30% 107%, #ff0000 #000000 0%, #000000 5%, #ff4500 45%);
  background-clip: text;
  -webkit-background-clip: text;
}
</style>
